__turbopack_context__.v({
  "arrow": "PopoverArrow-module__cYZR6W__arrow",
  "arrowFill": "PopoverArrow-module__cYZR6W__arrowFill",
  "arrowInnerStroke": "PopoverArrow-module__cYZR6W__arrowInnerStroke",
  "arrowOuterStroke": "PopoverArrow-module__cYZR6W__arrowOuterStroke",
});
